import Vue from 'vue'
import Vuex from 'vuex'
import Crud from '../crud'
import Catalogs from '../catalogs'
import app from '../../main'
import axios from 'axios'
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  notes: payload.notes,
  branch_id: payload.branch_id
})
var crud = new Crud('Shipments', model)
var catalogs = new Catalogs()

Vue.use(Vuex)

const state = {
  ...crud.state,
  ...catalogs.state,
  shipments: [],
  catalog: {},
  tabSheet: [],
  validOrder: false,
  approvedOrder: false,
  purchaseOrderDetails: [],
  trackinGuide: {},
  trackingGuides: [],
  trackingGuidesPagination: {
    currentPage: 1,
    perPage: 5,
    totalUsers: 0,
    totalPages: 0
  },
  convertedDetails: [],
  showSpreadSheet: true,
  isModalTrackingGuidesVisible: false,
  isModalTrackingGuidesFilesVisible: false,
  isModalCompleteShipmentVisible: false
}

const mutations = {
  ...crud.mutations,
  ...catalogs.mutations,
  SET_RECORDS (state, payload) {
    state.shipments = payload.data

    state.pagination = {
      currentPage: payload.meta.current_page,
      perPage: payload.meta.per_page,
      totalUsers: payload.meta.total,
      totalPages: payload.meta.last_page
    }
  },
  CONVERT_TO_ARRAY (state, payload) {
    var keys = [
      'folio_oc',
      'product_code',
      'shipment_quantity'
    ]
    var i = 0
    var k = 0
    var obj = null
    var output = []

    for (i = 0; i < payload.length; i++) {
      obj = {}

      for (k = 0; k < keys.length; k++) {
        obj[keys[k]] = payload[i][k]
      }
      output.push(obj)
    }
    state.convertedDetails = output
    return state.convertedDetails
  },
  SET_VALID_ORDER_DETAIL (state, payload) {
    state.validOrder = payload
  },
  SET_APPROVED_ORDER (state, payload) {
    state.approvedOrder = payload
  },
  SET_PURCHASE_ORDER_DETAILS (state, payload) {
    state.purchaseOrderDetails = []
    state.convertedDetails.forEach(function (element) {
      let purchaseOrder = payload.findIndex(u => u.product_code_display === element.product_code)
      if (purchaseOrder >= 0) {
        let data = { ...element, purchase_order_detail_id: payload[purchaseOrder].id, quantity: element.shipment_quantity.replace(/[^0-9.]/g, ''), quantity_to_validate: element.shipment_quantity.replace(/[^0-9.]/g, '') }
        state.purchaseOrderDetails.push(data)
      }
    })
  },
  CLEAN_SPREAD_SHEET (state) {
    state.tabSheet = []
  },
  SET_MODAL_TRACKING_GUIDES_VISIBLE (state, payload) {
    state.isModalTrackingGuidesVisible = payload
  },
  SET_MODAL_TRACKING_GUIDES_FILES_VISIBLE (state, payload) {
    state.isModalTrackingGuidesFilesVisible = payload
  },
  SET_MODAL_COMPLETE_SHIPMENT_VISIBLE (state, payload) {
    state.isModalCompleteShipmentVisible = payload
  },
  SET_TRACKING_GUIDES (state, payload) {
    state.trackingGuides = []
    state.trackingGuides = payload.data
    state.trackingGuidesPagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalUsers: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_TRACKING_GUIDE (state, payload) {
    state.trackinGuide = payload
  }
}

const actions = {
  ...crud.actions,
  ...catalogs.actions,
  async loadRecords ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`shipments/list?page=${payload.page}${this.getters['Shipments/filterParams']}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  cleanSpreadSheet ({ commit }, payload) {
    commit('CLEAN_SPREAD_SHEET')
  },
  convertToArrayOfObjects ({ commit }, payload) {
    commit('CONVERT_TO_ARRAY', payload)
  },
  async addShipment ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post(`shipments`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('CLEAN_SPREAD_SHEET')
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.shipment', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async validateOrderDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`shipments/ordered-product`, { details: payload })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data[0]) {
          commit('SET_PURCHASE_ORDER_DETAILS', response.data[1])
          commit('SET_VALID_ORDER_DETAIL', response.data[0])
        } else {
          commit('SET_VALID_ORDER_DETAIL', response.data[0])
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'shipments.not_found_title', text: response.data[4] }, { root: true })
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async purchaseOrderIsAproved ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`shipments/approved-order`, { details: payload })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data[0]) {
          commit('SET_APPROVED_ORDER', response.data[0])
        } else {
          commit('SET_APPROVED_ORDER', response.data[0])
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'Orden de compra no aprobada', text: response.data[2] }, { root: true })
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  setModalTrackingGuidesVisible ({ commit }, payload) {
    commit('SET_MODAL_TRACKING_GUIDES_VISIBLE', payload)
  },
  setModalTrackingGuidesFilesVisible ({ commit }, payload) {
    commit('SET_MODAL_TRACKING_GUIDES_FILES_VISIBLE', payload)
  },
  setModalCompleteShipmentVisible ({ commit }, payload) {
    commit('SET_MODAL_COMPLETE_SHIPMENT_VISIBLE', payload)
  },
  async loadTrackingGuides ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`tracking-guides?page=${payload.page}&shipment_id=${payload.shipment_id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_TRACKING_GUIDES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async saveTrackingGuide ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post(`tracking-guides`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_TRACKING_GUIDE', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.tracking_guide', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async saveTrackingGuideFiles ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    let formData = new FormData()
    payload.files.forEach(file => {
      formData.append('files[]', file)
    })
    formData.append('form', JSON.stringify({
      ...payload
    }))
    app.$Progress.start()
    try {
      const response = await axios.post(`tracking-guide-files`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.tracking_guide_files', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.finish()
    }
  },
  openFile ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${payload}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteTrackingGuideFile ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`tracking-guide-files/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.tracking_guide_file', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async checkBalanceStatus ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`purchase-orders/check-balance`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async checkBalanceByOrderDetail ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`/purchase-orders/check-balance-by-order-detail`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async updatePurchaseOrderDetailQuantities ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`/purchase-order-details/update-quantities-by-detail-id`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_order', text: 'Cantidades Actualizadas', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  ...catalogs.getters,
  shipments: state => state.shipments,
  tabSheet: state => state.tabSheet,
  validOrder: state => state.validOrder,
  approvedOrder: state => state.approvedOrder,
  trackinGuide: state => state.trackinGuide,
  trackingGuides: state => state.trackingGuides,
  trackingGuidesPagination: state => state.trackingGuidesPagination,
  purchaseOrderDetails: state => state.purchaseOrderDetails,
  convertedDetails: state => state.convertedDetails,
  showSpreadSheet: state => state.showSpreadSheet,
  isModalTrackingGuidesVisible: state => state.isModalTrackingGuidesVisible,
  isModalTrackingGuidesFilesVisible: state => state.isModalTrackingGuidesFilesVisible,
  isModalCompleteShipmentVisible: state => state.isModalCompleteShipmentVisible,
  suppliers: state => state.suppliers,
  catalog: state => state.catalog
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
